import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import useReveal from '../hooks/useReveal.js';
import { monoFont } from '../theme.js';

export function Eyebrow({ onDark = false, children }) {
  return (
    <Typography
      component="p"
      sx={{
        fontFamily: monoFont,
        fontSize: '0.75rem',
        fontWeight: 500,
        letterSpacing: '0.14em',
        color: onDark ? 'primary.main' : 'primary.dark',
        mb: 2,
      }}
    >
      {children}
    </Typography>
  );
}

export function SectionTitle({ onDark = false, children }) {
  return (
    <Typography variant="h2" sx={{ maxWidth: '24ch', mb: 5, color: onDark ? '#fff' : 'text.primary' }}>
      {children}
    </Typography>
  );
}

export function Section({ id, sx, children }) {
  const ref = useReveal();
  return (
    <Box component="section" id={id} sx={{ py: { xs: 8, md: 12 }, ...sx }}>
      <Container maxWidth="lg" ref={ref} className="reveal">
        {children}
      </Container>
    </Box>
  );
}
